export default "__VITE_PUBLIC_ASSET__4332e151__"